import React from 'react';
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import Results from '../Results/Results'
import NoResults from '../NoResults/NoResults'
import ErrorMessage from '../ErrorMessage/ErrorMessage'
import SuccessMessage from '../SuccessMessage/SuccessMessage'
import { Link } from 'react-router-dom'

export default class ResultsPage extends React.Component {
    constructor(props){
        super(props);
        // console.log(props);
        //Set the inital state if someone hits /results directly -- This is used to prevent undefined errors
        this.state = {
            jurisdictionIssueId: '000000000',
            documentKind : 'Other',
            issueDate: 'In Progress',
            mailDate: 'In Progress',
            mailTrackingInfo: 'N/A',
            error : null,
            
        };
        //Redirect to main page if directly hit /results
        if(this.props.history.location.state === undefined || this.props.history.location.state.data === undefined){
            this.props.history.push({pathname:'/', state:{error:"Could not pull license information"}});
        }
    }

    render() {
        const propErrors = this.props.history.location.state.data.error;
        const propSuccess = this.props.history.location.state.data.success;
        let propData = this.props.history.location.state.data.documents;

        let pageSuccess, pageError, pageBody, pageReturn;
        pageReturn = <Link className="w-3/4" to="/">
                <div className="mt-5 mb-5 mx-auto text-center sm:w-3/4 md:w-1/2 sm:px-3 sm:py-3 font-large rounded-md shadow-sm text-white bg-gradient-to-r from-blue-600 to-blue-900 hover:from-blue-700 hover:to-blue-900">
                    Return to Search Page
                </div>
                </Link>
	    if(propErrors){
            if(propErrors.find(error => error.includes("No matching record"))){
                pageError = 
                <>
                    <ErrorMessage error={propErrors}/>
                    <NoResults/>
                </>
                pageReturn = null;
            }else{
                pageError =<ErrorMessage error={propErrors}/>
            }
        }
        if(propSuccess){
            pageSuccess = <SuccessMessage success={propSuccess} />
        }
        if(propData){
        
		if(propData.length > 1){
                pageBody = propData.map((data, key) => {
                    return(
                        <div key={key}>
                            <Results status={data}/>
                        </div>
                    )
                    }) 
            }else if(propData.length == 1){
                pageBody = <Results status={propData[0]}/>
            }
	
        }
        return <div className="bg-gray-200 dark:bg-gray-900">
            <Header/>
            <div className="min-h-3/4">
                {pageSuccess}
                {pageError} 
	    	{pageReturn}
                {pageBody}
            </div>
            <Footer/>
        </div> 
    }
}
